// src/LoadingModal.js
import React, { useEffect } from "react";
import "./LoadingModal.css";

const LoadingModal = ({ isVisible, onClose }) => {
  useEffect(() => {
    if (!isVisible || !onClose) return;

    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        e.preventDefault();
        onClose();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isVisible, onClose]);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="loading-modal-overlay">
      <div className="loading-modal-content">
        <div className="loading-spinner"></div>
        <p>Please Wait, Loading Latest State Information</p>
        <small>(Hit Escape to Load in Background)</small>
      </div>
    </div>
  );
};

export default LoadingModal;
